module.exports = __webpack_public_path__ + "img/vulcano_greige_ba_list.e83e0692.jpg";